<template>
    <div id="chart">
        <apexcharts type="radar" height="350" :options="options" :series="series"></apexcharts>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
    name: "design-2021-apprentice-radar-chart-component",
    components: {
        apexcharts: VueApexCharts,
    },
    props: {
        series: {
            type: Array,
            default: null,
        },
        options: {
            type: Object,
            default: null,
        },
    },
}
</script>

<style scoped>

</style>
